<template>
    <v-card outlined v-bind="{ to }">
        <v-img :src="value.thumb?.src" :aspect-ratio="16 / 9" class="grey-f7" content-class="d-flex flex-column justify-start">
            <template #placeholder>
                <v-layout justify-center align-center fill-height>
                    <v-icon x-large color="grey lighten-4">mdi-image-broken-variant</v-icon>
                </v-layout>
            </template>
            <v-col cols="auto">
                <card-badges v-bind="{ value }" />
            </v-col>
        </v-img>
        <v-divider />
        <v-row class="ma-0" align="center">
            <v-col class="pa-16 font-size-18 font-weight-bold text-truncate">
                {{ value?.subject }}
            </v-col>
            <v-col cols="auto" class="pa-16">
                <v-chip small outlined>{{ value?.meta?.watcherCount?.format?.() }}명 참여</v-chip>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { initLecture } from "@/store/lecture";

import CardBadges from "./card/card-badges.vue";

export default {
    components: {
        CardBadges,
    },
    props: {
        value: { type: Object, default: initLecture },
    },
    computed: {
        to() {
            return `/lectures/${this.value?._id}`;
        },
    },
};
</script>

<style></style>
